import { ProjectType } from "@/types";
import { create } from "zustand";
// import { createJSONStorage, persist } from 'zustand/middleware';

// Store pour gérer le pourcentage
const usePercentageStore = create<{
  enablePreviewLine?: boolean;
  setEnablePreviewLine: (val: boolean) => void;
  percentage: number;
  setPercentage: (value: number) => void;
  resetPercentage: () => void;
}>((set) => ({
  percentage: 0,
  enablePreviewLine: true,
  setEnablePreviewLine: (value) => set({ enablePreviewLine: value }),
  setPercentage: (value) => set({ percentage: value }),
  resetPercentage: () => set({ percentage: 0 }),
}));

type ProjectState = {
  project: ProjectType | null;
  setProject: (project: ProjectType) => void;
};

const useProjectStore = create<ProjectState>((set) => ({
  project: null,
  setProject: (project) => set({ project }),
}));

// Store pour gérer l'état des modals
const useModal = create<{
  modals: { [key: string]: boolean };
  setOpenModal: (modal: { name: string; value: boolean }) => void;
}>((set) => ({
  modals: {},
  setOpenModal: ({ name, value }) =>
    set((state) => ({
      modals: {
        ...state.modals,
        [name]: value,
      },
    })),
}));

// Clé utilisée pour stocker les données dans localStorage
const STORAGE_KEY = "previewPerformance";

const usePreviewPerformance = create<{
  previews: { [key: string]: string };
  setPreviews: (preview: { name: string; value: string }) => void;
}>((set) => ({
  // Initialisation des données depuis localStorage
  previews: JSON.parse(localStorage.getItem(STORAGE_KEY) || "{}"),

  // Mise à jour de l'état et de localStorage
  setPreviews: ({ name, value }) => {
    set((state) => {
      const updatedPreviews = {
        ...state.previews,
        [name]: value,
      };

      // Synchronisation avec localStorage
      localStorage.setItem(STORAGE_KEY, JSON.stringify(updatedPreviews));

      return { previews: updatedPreviews };
    });
  },
}));

const useLeftbar = create<{
  isOpen: boolean;
  setIsOpen: (value: boolean) => void;
}>((set) => ({
  // Initialisation des données depuis localStorage
  isOpen: JSON.parse(localStorage.getItem("leftbarState") || "false"),

  // Mise à jour de l'état et de localStorage
  setIsOpen: (value) => {
    set(() => {
      // Synchronisation avec localStorage
      localStorage.setItem("leftbarState", JSON.stringify(value));
      return { isOpen: value };
    });
  },
}));

type TabState = {
  tab: "descriptif" | "suivi-perf" | "reporting";
  setTab: (tab: "descriptif" | "suivi-perf" | "reporting") => void;
};

const useTabDashboard = create<TabState>((set) => ({
  tab: "descriptif",
  setTab: (tab) => set({ tab }),
}));

const useCustomTheme = create<{
  isVisible: boolean;
  setIsVisible: (value: boolean) => void;
}>((set) => ({
  // Initialisation des données depuis localStorage
  isVisible: false,
  // Mise à jour de l'état et de localStorage
  setIsVisible: (value) => {
    set(() => {
      return { isVisible: value };
    });
  },
}));

interface LogoStore {
  logoUrl: string;
  setLogoUrl: (url: string) => void;
}

const useLogoStore = create<LogoStore>((set) => ({
  logoUrl: "", // Valeur par défaut
  setLogoUrl: (url: string) => set({ logoUrl: url }),
}));

export {
  useCustomTheme,
  useLeftbar,
  useLogoStore,
  useModal,
  usePercentageStore,
  usePreviewPerformance,
  useProjectStore,
  useTabDashboard,
};
